import { Box, Divider, Popover, Stack, Typography, alpha } from '@mui/material';

interface CustomDayOfMonthSelectorProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  value: number;
  onChange: (day: number) => void;
}

export const CustomDayOfMonthSelector = ({
  anchorEl,
  onClose,
  value,
  onChange,
}: CustomDayOfMonthSelectorProps) => {
  return (
    <Popover
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
    >
      <Box p={2} maxWidth={330}>
        <Stack spacing={1}>
          <Stack spacing={1} pb={2}>
            <Typography variant="subtitle2">
              Select the date on which you want the report to be sent every
              month
            </Typography>
            <Divider />
          </Stack>
          <Stack
            sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(6, 1fr)',
              gridTemplateRows: 'repeat(5, 1fr)',
              gap: '5px',
              px: 3,
            }}
          >
            {Array.from({ length: 30 }).map((_, index) => {
              const day = index + 1;
              const isSelected = value === day;

              return (
                <Stack
                  sx={{
                    width: '30px',
                    height: '30px',
                    borderRadius: '50%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    bgcolor: isSelected ? 'primary.main' : undefined,
                    color: isSelected ? 'primary.contrastText' : undefined,
                    cursor: 'pointer',
                    '&:hover': !isSelected
                      ? {
                          bgcolor: (theme) =>
                            alpha(theme.palette.text.primary, 0.1),
                        }
                      : undefined,
                  }}
                  onClick={() => onChange(day)}
                  key={day}
                >
                  <Typography variant="subtitle2">{day}</Typography>
                </Stack>
              );
            })}
          </Stack>
        </Stack>
      </Box>
    </Popover>
  );
};
